"use client";
import useSWR from "swr";
import { useTranslations } from "next-intl";
import { Menu } from "@/dto/menu";
import { Merchant } from "@/dto/merchant";
import { MenuCategoriesList } from "@/components/menu/menuCategoriesList";
import { getRestaurantMenuAction } from "../actions";
import { getMenuQueryParams } from "@/utils/menus";

interface RestaurantMenuItemsProps {
  menu: Menu | null;
  merchant: Merchant;
  merchantId: string;
  menuId?: string;
  searchParams: { [key: string]: string | string[] | undefined };
  itemTemplate?: string;
  query?: string;
}

export const RestaurantMenuItems = ({
  menu,
  merchant,
  merchantId,
  menuId,
  searchParams,
  itemTemplate,
  query,
}: RestaurantMenuItemsProps) => {
  const swrKey = JSON.stringify({ order_type: searchParams.order_type, menu: searchParams.menu });
  const { data } = useSWR(
    ["restaurantMenu", merchantId, swrKey],
    () => getRestaurantMenuAction(merchantId, searchParams, menuId),
    {
      fallbackData: { menu },
      revalidateOnMount: false,
      revalidateOnFocus: true,
    }
  );
  const activeMenu = data?.menu ?? menu;
  const { name: merchantName } = merchant;
  const tRestaurant = useTranslations("restaurantMenu");

  const queryParams = getMenuQueryParams(searchParams);

  const getBaseRoute = (isEssential: boolean) =>
    isEssential ? "/categories" : "/menu";

  const baseRoute = getBaseRoute(merchant.isEssentialMerchant);

  if (!activeMenu) return null;

  return (
    <MenuCategoriesList
      menu={activeMenu}
      merchantName={merchantName}
      itemTemplate={itemTemplate}
      query={query ?? ""}
      baseRoute={baseRoute}
      queryParams={queryParams}
      uncategorizedLabel={tRestaurant("uncategorized")}
    />
  );
};
